import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box } from "@mui/material";
import { ReactComponent as NoteIcon } from "../../../../assets/icons/note.svg";
import { ParagraphText } from "../../../../Libraries";
import { formatNum } from "../../../../oscar-pos-core/constants";
import styles from "./styles.module.css";

const TotalSummaryCard = ({
  note = "",
  subTotal = 0,
  discount = 0,
  tax = 0,
  discountMethod = "rs",
  calculateTotalAmountOrder,
  totalDiscountPerItem = 0,
}) => {
  const [order, setOrder] = useState({
    discount: 0,
    total: 0,
    tax: 0,
  });

  const [I18n] = useContext(LanguageContext);

  useEffect(() => {
    const calculateDiscountVal =
      discountMethod === "rs" ? discount : (subTotal * discount) / 100;
    let total = subTotal - calculateDiscountVal;
    const calculateTaxPercent = (total * tax) / 100;
    total += calculateTaxPercent;
    setOrder({
      discount: calculateDiscountVal,
      tax: calculateTaxPercent,
      total: total,
    });

    calculateTotalAmountOrder?.(total);
  }, [discountMethod, totalDiscountPerItem, tax, subTotal, discount]);

  return (
    <Box className={styles.container}>
      

      <Box className={styles.summaryRow}>
        <ParagraphText className={styles.label} id="subtotal_label">
          {I18n.subtotal}
        </ParagraphText>
        <ParagraphText className={styles.value} id="subtotal_value">
          Rs. {formatNum(subTotal)}
        </ParagraphText>
      </Box>

      {order.tax ? (
        <Box className={styles.summaryRow}>
          <ParagraphText className={styles.label} id="tax_label">
            {I18n.tax}
          </ParagraphText>
          <ParagraphText className={styles.value} id="tax_value">
            {tax}% (Rs. {formatNum(order.tax)})
          </ParagraphText>
        </Box>
      ) : null}

      {order.discount || discountMethod === "%" ? (
        <Box className={styles.summaryRow}>
          <ParagraphText className={styles.label} id="discount_label">
            {I18n.discount}
          </ParagraphText>
          {discountMethod === "rs" ? (
            <ParagraphText className={styles.value} id="discount_value">
              -Rs. {formatNum(order.discount)}
            </ParagraphText>
          ) : (
            <ParagraphText className={styles.value} id="discount_value">
              -{discount}% (Rs. {formatNum(order.discount)})
            </ParagraphText>
          )}
        </Box>
      ) : null}

      <Box className={styles.totalRow}>
        <ParagraphText className={styles.totalLabel} id="total_label">
          {I18n.total}
        </ParagraphText>
        <ParagraphText className={styles.totalValue} id="total_value">
          Rs. {formatNum(order.total)}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default TotalSummaryCard;
